import styled, { css } from 'styled-components'

export const Container = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => props.textAlign};
  list-style: none;
  margin-left: 0;

  ${(props) =>
    props.noMargin &&
    css`
      margin-bottom: 0;
    `}
`
export const Callout = styled.li`
  flex: none;
  font-size: 0.75rem;

  ${(props) =>
    css`
      && {
        font-weight: ${props.theme.font.weight.bold};
        line-height: 1.4;
      }
      border: ${props.theme.size.border.width.sm} solid ${props.theme.color.monochrome.light};
      border-radius: ${props.theme.channel === 'nectar' ? props.theme.size.border.radius.base : 0};
      color: ${props.theme.color.monochrome.base};
      margin: 0 ${props.theme.size.spacing.md} ${props.theme.size.spacing.lg} 0;
      padding: ${props.theme.size.spacing.sm} ${props.theme.size.spacing.md};
    `}
`
